import React, {useEffect, useState} from "react";
import {NavLink} from 'react-router-dom';
import {useSelector} from "react-redux";
import AppConstants from "../../Config/AppConstants";
function Footer() {
    const dataMenus = useSelector(state => state.bodySlice.menu);
    return (
       <>
            <footer id='footer'>
                <div className="footer-menu">
                    <div className="container">
                        <NavLink to="/" title={AppConstants.domainPage}> Home </NavLink>
                        <NavLink to="/terms" title='Terms &amp; Conditions'> Terms </NavLink>
                        <NavLink to="/policy" title='Privacy Policy'>Privacy policy </NavLink>
                        <a href="/document.html"target="_blank">Api document</a>
                    </div>
                </div>
                <div className="footer-link">
                    <div className="container">
                        {
                            dataMenus.map(item => {
                                return (
                                    <h2 className="col-sm-2 tag-footer-menu  col-md-2"  key={"menu-list-"+item.id}>
                                        <NavLink to={`/categorices/${item.alias}`} title={item.title}>
                                           {item.title}
                                        </NavLink>
                                    </h2>
                                )
                            })
                        }
                        <h2 className="col-sm-2 tag-footer-menu  col-md-2"  key={"menu-list-jav"}>
                            <NavLink to={`/jav`} title='jav'>
                                Jav
                            </NavLink>
                        </h2>
                        <h2 className="col-sm-2 tag-footer-menu  col-md-2"  key={"menu-list-jav-hd"}>
                            <NavLink to={`/jav-hd`} title='jav'>
                                Jav HD
                            </NavLink>
                        </h2>
                        <h2 className="col-sm-2 tag-footer-menu  col-md-2"  key={"menu-list-fc2ppv"}>
                            <NavLink to={`/categorices/fc2ppv`} title='fc2ppv'>
                                fc2ppv
                            </NavLink>
                        </h2>
                        <h2 className="col-sm-2 tag-footer-menu  col-md-2"  key={"menu-list-Jav-free"}>
                            <NavLink to={`/jav-free`} title='Jav free'>
                                Jav free
                            </NavLink>
                        </h2>
                        <h2 className="col-sm-2 tag-footer-menu  col-md-2"  key={"Watch-Jav-online-free"}>
                            <NavLink to={`/watch-jav-online-free`} title='Watch Jav online free'>
                                Watch jav online free
                            </NavLink>
                        </h2>
                    </div>
                </div>
            </footer>

        </>
    );
}

export default Footer;
